export default __webpack_public_path__ + "static/media/white_royal_queen.943ba844.png";